module.exports = __webpack_public_path__ + "img/Result_Beginner_0608_01_2.d45495b2.png";